import { render, staticRenderFns } from "./FeaturedSelect.vue?vue&type=template&id=0c8c0f9c&scoped=true"
import script from "./FeaturedSelect.vue?vue&type=script&lang=js"
export * from "./FeaturedSelect.vue?vue&type=script&lang=js"
import style0 from "./FeaturedSelect.vue?vue&type=style&index=0&id=0c8c0f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8c0f9c",
  null
  
)

export default component.exports